import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as stageActions from '../../actions/stages';
import Select from '../form/select';
import LocalizedStrings from '../../localization/strings';

class DistanceSelection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            distances: [],
            stage: null,
            selectedDistance: null,
            selectedSeason: window.CARE_CONFIG.settings.season ? window.CARE_CONFIG.settings.season.id : null
        };
    }

    componentWillMount() {
        this.props.actions.fetchAllStages();
    }

    getStage(id) {
        const {stages} = this.props;
        let stageById;
        stages.forEach((stage) => {
            if (stage.id === id) {
                stageById = stage;
            }
        });
        return stageById;
    }

    onStageChange(stageField) {
        let distances = [];
        if (stageField.value) {
            const stage = this.getStage(stageField.value);
            if (stage) {
                distances = stage.distances;
            }
        }
        this.onChage({stage: stageField, selectedDistance: null, distances});
    }

    onChage(newState) {
        const newStateUpdated = {...this.state, ...newState}
        this.setState(newState);
        if (this.props.onChange) {
            this.props.onChange({stage: newStateUpdated.stage, distance: newStateUpdated.selectedDistance, season: newStateUpdated.selectedSeason});
        }
    }

    onDistanceChange(distance) {
        this.onChage({selectedDistance: distance});
    }

    onSeasonChange(season) {
        this.onChage({selectedSeason: season, selectedDistance: null, stage: null});
    }

    getSeasons(stages) {
        var seasons = [];
        stages.forEach((stage) => {
            seasons.push(stage.season);
        });
        var filtered = [];
        return seasons.filter((season) => {
            if (filtered.indexOf(season.id) > -1) {
                return false;
            } else {
                filtered.push(season.id);
                return true;
            }
        });
    }

    getStages(season, stages) {
        return stages.filter((stage) => {
            return stage.season.id === season;
        })
    }

    render() {
        const {stages} = this.props;
        const seasons = this.getSeasons(stages);
        const stageItems = this.getStages(this.state.selectedSeason, stages);

        return (
            <div>
                <Select options={seasons} clearable={false} value={this.state.selectedSeason}
                        noResultsText={LocalizedStrings.noSeasons} placeholder={LocalizedStrings.season}
                        onChange={this.onSeasonChange.bind(this)} simpleValue={true}/>

                <Select options={stageItems} clearable={false} value={this.state.stage}
                        noResultsText={LocalizedStrings.noStages} placeholder={LocalizedStrings.stage}
                        onChange={this.onStageChange.bind(this)}/>
                <Select options={this.state.distances} clearable={false} value={this.state.selectedDistance}
                        noResultsText={LocalizedStrings.noDistances} placeholder={LocalizedStrings.distance}
                        onChange={this.onDistanceChange.bind(this)}/>
            </div>
        )
    }
}

export default connect(function (state) {
    return {stages: state.stage.availableStages.items}
}, function (dispatch) {
    return {
        actions: bindActionCreators(stageActions, dispatch)
    }
})(DistanceSelection);



// WEBPACK FOOTER //
// ./src/js/components/stage/distance-selection.js